import { render } from "./page.vue?vue&type=template&id=4d4d619e&scoped=true&ts=true"
import script from "./page.vue?vue&type=script&lang=ts"
export * from "./page.vue?vue&type=script&lang=ts"

import "./page.vue?vue&type=style&index=0&id=4d4d619e&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4d619e"]])

export default __exports__